/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext } from 'react';
import { CpdsIconStyleTag } from './styles/cpds-icon-style';
import { CpdsIconProps } from './typings';
import { themeStyleClass } from '../utils/cpds-utils';
import { BexIcons, GlobalIcons, HotelIcons, MesoIcons, VerboIcons } from './icons';
import { ThemeContext } from 'styled-components';

const IconSize = {
  extra_small: { width: '10', height: '9' },
  small: { width: '15', height: '14' },
  medium: { width: '20', height: '18' },
  large: { width: '25', height: '23' },
  xlarge: { width: '30', height: '28' },
  xxlarge: { width: '51', height: '53' },
};

const loadSVG = (type : string = 'brand', brand: string = 'expedia', name: string) => {
  const brandIcons = {
    'expedia': BexIcons,
    'hotels': HotelIcons,
    'vrbo': VerboIcons
  };

  if (type === 'brand') {

    if (GlobalIcons[name]) return GlobalIcons[name];
    if (!brand) return GlobalIcons['help'];

    const icon = brandIcons[brand][name] || brandIcons['expedia'][name] || brandIcons['hotels'][name] || brandIcons['vrbo'][name] ||  MesoIcons[name] ;
    return icon || GlobalIcons['help'];
  } else if (type === 'meso') {
    return MesoIcons[name] || loadSVG('brand', 'expedia', name);
  } else {
    return GlobalIcons['help'];
  }
};

const CpdsIcon: React.FC<CpdsIconProps> = (props) => {
  const {styles}: any = useContext(ThemeContext);  
  const { domRef, exClasses, styleOverrides, id, name, size, color, customSize, themeTypography} = props;
  const type = styles?.cpds?.themeType || 'brand';
  const brand = styles?.cpds?.brand || 'expedia';

  const { path, fill, circle, rect, fillRule, clipRule, viewBox } = loadSVG(type, brand, name);
  
  const { width, height } = customSize || IconSize[size] || { width: '20', height: '18' };
  const className = themeStyleClass('cpds-icon', themeTypography, exClasses);  
 
  const genPath = () => {
    if (typeof path === 'string') {
      const validFillRules = ["inherit", "evenodd", "nonzero"];
      const safeFillRule = validFillRules.includes(fillRule) ? fillRule : 'inherit';
    
      return <path fillRule={safeFillRule} clipRule={`${clipRule || ''}`} d={path} fill={color || fill} />;
    } else if (Array.isArray(path)) {
      return path.map((p, i) => <path key={i} fillRule={`evenodd`} clipRule={`evenodd`} d={p.d} fill={color || p.fill} stroke={p?.stroke || ''} />);
    }
  };

  /* Important : By default html tag is <div></div> 
  but you can change that into suitable html element base on your requirements*/
  return (
    <CpdsIconStyleTag
      id={id}
      key={id}
      className={className} 
      ref={domRef} 
      styleOverrides={styleOverrides} 
      width={width} 
      height={height} 
      viewBox={`${viewBox ? viewBox : ' 0 0 24 24'}`} 
      fill="none" xmlns="http://www.w3.org/2000/svg">
      { circle && <circle cx={`${circle?.cx}`} cy={`${circle?.cy}`} r={`${circle?.r}`} fill={`${circle?.fill || (color || fill)}`}  /> }
      { rect && <rect x={`${rect?.cx}`} y={`${rect?.cy}`} width={`${rect?.width}`} height={`${rect?.height}`}  rx={`${rect?.rx || ''}`} stroke={`${rect?.stroke || (color || fill)}`}  /> }
      { path && genPath()}
    </CpdsIconStyleTag>
  );
};

export default CpdsIcon;
